export const allowedSwitchStatusesKeywordsForLinking = [
  "Expired",
  "Delivered_Prescriber_Fax",
  "No_prescriber_response",
  "No_prescriber_contact",
  "Ninty_day_close_missing_data",
  "Active_Delayed",
  "Missing_Prescriber_Contact_Info",
  "EXPIRED_BEFORE_FAX_SENT_TO_PRESCRIBER",
  "EXPIRED_AFTER_FAX_SENT_TO_PRESCRIBER",
  "Failed_Prescriber_Fax",
  "Failed_Pharmacy_Fax",
  "CLOSED_WHILE_EXPIRED_DUE_TO_NO_PRESCRIBER_RESPONSE"
];
export const GET_MEMBER_SWITCH_LIST_REQUEST = "GET_MEMBER_SWITCH_LIST_REQUEST";
export const GET_MEMBER_SWITCH_LIST_SUCCESS = "GET_MEMBER_SWITCH_LIST_SUCCESS";
export const GET_MEMBER_SWITCH_LIST_FAILURE = "GET_MEMBER_SWITCH_LIST_FAILURE";
export const RESET_MEMBER_SWITCH_LIST = "RESET_MEMBER_SWITCH_LIST";
